<template>
<v-card class="d-md-none">

  <div class="video-responsive" v-if="show_video_player">
    <iframe :id="`iframe-${random_id}`" :src="videoIframe" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" autoplay></iframe>
  </div>


  <v-img :aspect-ratio="16/9" :src="project.thumbnail_large" v-else @click="showVideo">
    <v-row class="white--text pa-2 fill-height">
      <div class="btn-box">
        <div class="box-overlay">

        </div>
        <v-btn color="primary">
          <v-icon small>fa-play</v-icon>
        </v-btn>
      </div>
    </v-row>
  </v-img>


  <v-card-actions class="px-4 py-1 " @click="show_more=!show_more">
    <v-btn icon>
      <v-icon v-if="!show_more">fa-chevron-down</v-icon>
      <v-icon v-if="show_more">fa-minus</v-icon>
    </v-btn>
    <v-spacer>
    </v-spacer>
    <v-btn rounded x-small fab dark color="cool_purple"><span> <v-icon x-small>fas fa-dollar-sign</v-icon></span></v-btn>
  </v-card-actions>

  <v-expand-transition>
    <div v-show="show_more">
      <v-divider></v-divider>
      <v-card-text>
        <router-link class="nolink secondary--text" :to="`/project/${project.id}/${project.slug}`">
          <h3>{{project.title}}</h3></router-link>
        {{project.summary}}
        <router-link v-if="project.summary" class="nolink ml-2" :to="`/project/${project.id}/${project.slug}`">See more</router-link>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="px-4 grey lighten-3">
        <h5>Support</h5>
        <v-spacer></v-spacer>
        <v-chip @click="sponsor_project(option)" class="ma-2 clicky" color="green" text-color="white" v-for="(option,i) in  $store.getters['app/supportOptions']" :key="i">
          <v-avatar left class="white">
            <v-icon small color="green">fa-dollar-sign</v-icon>
          </v-avatar>
          {{option}}
        </v-chip>
      </v-card-actions>
    </div>
  </v-expand-transition>
</v-card>
</template>
<script>
export default {
  props: ['project'],
  name: "",
  data: () => ({
    show_video_player: false,
    random_id: Math.round(Math.random() * 100000),
    show_more: false
  }),
  methods: {
    showVideo() {
      this.show_video_player = true
    },
    pauseVideos() {
      try {
        Array.from(document.querySelectorAll("iframe")).forEach(v => {
          try {
            v.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
          } catch (ex) {
            console.error(ex)
          }
        })
      } catch (ex) {
        console.error(ex)
      }

    },
    sponsor_project(option) {
      this.pauseVideos()
      this.$eventBus.$emit('support', {
        project_id: this.project.id,
        account_id: this.project.account_id,
        option: option
      })
    }
  },
  computed: {
    videoIframe() {
      return this.$helpers.iframeFromUrl(this.project.url) + "?autoplay=1&enablejsapi=1"
    }
  }
}
</script>
<style lang="scss" scoped>
.box-overlay {
    background: black;
    opacity: 0.5;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
}
.btn-box {
    width: 100%;
    height: 100%;
    align-items: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    justify-content: center;
    align-items: center;
    display: flex;
}
.video-responsive {
    overflow: hidden;
    padding-bottom: 56.25%;
    position: relative;
    height: 0;
}
.video-responsive iframe {
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    position: absolute;
}
</style>
